import { Box } from '@creditas-ui/layout';
import { styled } from '@creditas-ui/system';
import { selectTheme } from '@creditas-ui/utilities';

const Item = styled(Box)`
  padding: 24px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${selectTheme('colors.neutral.10')};

  &:active {
    background-color: ${selectTheme('colors.neutral.10')};
  }
`;

export { Item };
